import { lazy } from "react";

export const RouteChange = lazy(() => import("./RouteChange"));
export const RouteChangeModal = lazy(() => import("./RouteChangeModal"));
export { type OptionType } from "./RouteChange";
